import React from "react";
import { ErrorMessage, Field } from "formik";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import { validateEmail } from "../../../utilities/ValidationHelper";

const ContactInfo = () => {
  const CONTACT_INFO_STEP_STRINGS =
    GeneralStrings.ENROLL.FORM_LABELS.CONTACT_INFO_STEP;

  return (
    <div className="step">
      <h4 className="step-header">{CONTACT_INFO_STEP_STRINGS.HEADER}</h4>
      <div className="question-container">
        <div className="form-group">
          <Field
            name="email"
            className="form-control"
            placeholder={GeneralStrings.FORM.EMAIL}
            validate={validateEmail}
          />
          <ErrorMessage component="span" className="form-error" name="email" />
        </div>
        <div className="form-group">
          <Field
            name="phoneNumber"
            className="form-control"
            placeholder={GeneralStrings.FORM.FORM_LABELS.PHONE_NUMBER}
          />
          <ErrorMessage
            component="span"
            className="form-error"
            name="phoneNumber"
          />
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
